import React from 'react';

import { changeDateFormate } from '../../utils/dateFormat';

export type DateTemplateProps = string | number | Date;

export const DateTemplate = (rowData: DateTemplateProps) => {
    return <span>{changeDateFormate(rowData)}</span>;
};
